import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  background-color: ${color.white};
  padding: 24px;
  padding-top: 0;
  overflow-y: scroll;
  flex-grow: 2;
  :first-child {
  }
  .component_detailAd_grid {
    padding-top: 24px;
    max-width: 100%;
    display: grid;
    grid-template-columns: 50% 50%;
    row-gap: 24px;
    color: ${color.black1};
    font-size: 16px;
    .fullWidth {
      grid-column: span 2;
    }
    .field {
      color: ${color.black2};
      font-size: 14px;
      font-weight: 600;
    }
    .budget {
      font-weight: 700;
    }
    .url {
      overflow-wrap: break-word;
      word-wrap: break-word;

      -ms-word-break: break-all;
      /* This is the dangerous one in WebKit, as it breaks things wherever */
      word-break: break-all;
      /* Instead use this non-standard one: */
      word-break: break-word;

      /* Adds a hyphen where the word breaks, if supported (No Blink) */
      -ms-hyphens: auto;
      -moz-hyphens: auto;
      -webkit-hyphens: auto;
      hyphens: auto;
    }
  }
`;

export default Wrapper;
